import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import chakraTheme from "./theme/theme";
import "./assets/css/app.css";
import {Toaster} from "react-hot-toast";
import axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk as thunkMiddleware } from "redux-thunk";
import App from "./App";
import {CurrencyProvider} from "./components/Main/context/CurrencyContext";
import { TwoFactorProvider } from "./tools/twoFactor";
import Global from "./reducer/global";
import { config } from './config/environment';


const envConfig = config

axios.defaults.headers.common['admin'] = "true"
axios.defaults.headers.common['Language'] = "fr"
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Isl-Token'] = JSON.parse(localStorage.getItem("creativeAdminToken"))
axios.defaults.baseURL = envConfig.apiUrl;

axios.interceptors.response.use(
    response => {
        return { data: response.data };
    },
    error => {
        return Promise.reject(error);
    }
);

const Reducers = combineReducers({
    "global": Global,
});

const store = createStore(Reducers, undefined, compose(applyMiddleware(thunkMiddleware)));

// Créer une "root" avec React 18
const root = ReactDOM.createRoot(document.getElementById("root")); // Utilisation de createRoot

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <CurrencyProvider>
                <TwoFactorProvider>
                    <ChakraProvider theme={chakraTheme} resetCSS={false}>
                        <ColorModeScript initialColorMode="dark" />
                        <App />
                    </ChakraProvider>
                </TwoFactorProvider>
            </CurrencyProvider>
        </BrowserRouter>
        <Toaster
            position="bottom-left"
            reverseOrder={false}
        />
    </Provider>
);
